import { NavLink, Outlet } from "react-router-dom";
import { useSession } from "../../stores/session";

const NAV = [
  ["/admin/overview", "概览"],
  ["/admin/towns", "小镇"],
  ["/admin/mayors", "城主"],
  ["/admin/users", "用户"],
  ["/admin/audit", "审计"],
] as const;

export default function AdminLayout() {
  const { user, logout } = useSession();
  return (
    <div className="min-h-screen bg-[#f3f0e6] text-[#28251f]">
      <header className="border-b border-[#ddd7c4] bg-[#18352f] text-white">
        <div className="mx-auto flex max-w-7xl items-center gap-6 px-5 py-3">
          <a href="/admin/overview" className="text-lg font-black tracking-wide">星原平台</a>
          <nav className="flex flex-1 items-center gap-1 overflow-x-auto">
            {NAV.map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) => `rounded-md px-3 py-2 text-sm font-medium ${
                  isActive ? "bg-white/15 text-white" : "text-[#c8d8d2] hover:bg-white/10"
                }`}
              >
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-3 text-sm sm:flex">
            <span className="text-[#c8d8d2]">{user?.username}</span>
            <button onClick={logout} className="rounded-md border border-white/20 px-3 py-1.5 hover:bg-white/10">
              退出
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-6">
        <Outlet />
      </main>
    </div>
  );
}
